export var defaultlabelForNotFound = 'Не найдено';
export var defaultlabelForCreate = '+';
export var defaultLabelForEmptyItems = 'Список пуст';
export var getInputWidth = function (controlInnerRef, helperInputFakeElement) {
    if (!controlInnerRef.current || !helperInputFakeElement.current) {
        return 20;
    }
    var fakeElWidth = helperInputFakeElement.current.offsetWidth + 20;
    var maxWidth = controlInnerRef.current ? controlInnerRef.current.offsetWidth - 15 : 2;
    var width = fakeElWidth > maxWidth ? maxWidth : fakeElWidth;
    return width;
};
